import operator from './modules/operator';
import videoCall from './modules/video-call';

export default {
	operator,
	videoCall,
};
